export default __webpack_public_path__ + "static/media/interior.80a1dbbf.svg";